import { Platform } from 'react-native';

/**
 *
 * @returns true if Platform is 'android'
 */
export const isAndroidDevice = () => {
  return Platform.OS === 'android';
};
